/* eslint-disable import/no-import-module-exports */
import { configureStore as configureStoreToolkit } from '@reduxjs/toolkit';
import throttle from 'lodash/throttle';
import createHelpers from './createHelpers';
import { saveState, saveLocalState } from '../utils/StorageUtils';
import { rootReducer } from './rootReducer';
import { appAPI } from '../services/api';

export const configureStore = (initialState: any, helpersConfig: any) => {
  const helpers = createHelpers(helpersConfig);

  // https://redux.js.org/docs/api/createStore.html
  // const store = createStore(rootReducer, initialState, enhancer);
  const store = configureStoreToolkit({
    reducer: rootReducer,
    preloadedState: initialState,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        thunk: {
          extraArgument: helpers,
        },
        // serializableCheck: false, // need to fix this
        // immutableCheck: false, // need to fix this
      }).concat(appAPI.middleware),
  });

  // Hot reload reducers (requires Webpack or Browserify HMR to be enabled)
  if (__DEV__ && module.hot) {
    module.hot.accept('./rootReducer', () =>
      import('./rootReducer').then(reducerModule => {
        store.replaceReducer(reducerModule.rootReducer);
      }),
    );
  }

  store.subscribe(
    throttle(() => {
      const currentState = store.getState();
      saveState({
        user: currentState.user,
      });

      saveLocalState({
        clients: currentState.clients,
      });
    }, 1000),
  );

  return store;
};

type StoreType = ReturnType<typeof configureStore>;

export type AppState = ReturnType<StoreType['getState']>;

export type AppDispatch = StoreType['dispatch'];
